$("#select-categories").on('change', function() {
    spei.refresh.areas()
})  

$("#btn-search").on('click', function () {
    spei.refresh.src()
})

$("#btn-download").on('click', function () {
    spei.download()
})

let spei = {
    source: "spei",
    selected: { id: "17145", category: "PA", acronym: "BR", name: "BRASIL"},
    workspace: '/platform',
    today: new Date(),
    init: {
        all: () => {
            $("#img-data").on('load', () => $("#btn-download").prop('disabled', false))
            $("#img-data").on('error', () => $("#btn-download").prop('disabled', true))
            spei.init.toastr()
        },
        toastr: () => {
            toastr.options = {
                "closeButton": true,
                "debug": false,
                "newestOnTop": true,
                "progressBar": true,
                "positionClass": "toast-top-right",
                "preventDuplicates": true,
                "onclick": null,
                "showDuration": "300",
                "hideDuration": "1000",
                "timeOut": "5000",
                "extendedTimeOut": "1000",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            }
        }
    },
    download: () => {
        const link = document.createElement('a')
        link.href = $('#img-data').attr('src')
        link.download = `ALARMES-LASA-${spei.source.toUpperCase()}-FULL-${spei.today.toISOString().split('T')[0].replace(/-/g, "")}` // Nome do arquivo ao baixar

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    },
    refresh: {
        areas: () => {
            $.getJSON(`${spei.workspace}/area/info/${$("#select-categories").val()}`, function (areas) {
                let elem = $('#select-areas').empty()
                console.log(areas)
                for (i in areas)
                    elem.append(`<option value="${areas[i].id}" pa="BR" bi="${areas[i].biome_id}" uf="${areas[i].uf}" >${areas[i].name}</option>`)
                })
        },
        src: () => {
            toastr.info("Atualizando...")
            $("#btn-search").prop('disabled', true).html(`<div class="spinner-border spinner-border-sm mt-1"></div>`)

            spei.selected.category   = $("#select-categories").val()
            spei.selected.id         = $("#select-areas").val()
            spei.selected.acronym    = $("#select-areas option:selected").attr(spei.selected.category.toLowerCase())
            spei.selected.name       = $("#select-areas option:selected").text().toUpperCase().replace(/\s+/g, '-')
                
            console.log(spei.selected)
            $("#img-data").attr("src", `${spei.workspace}/generated/${spei.source}/full/SPEI_${spei.selected.category}_${spei.selected.id}.png`)
            
            $("#img-data").on("load", function () {
                $("#btn-search").prop('disabled', false).html(`Buscar&nbsp;<i class="fa fa-search"></i>`)
            })
        
        }

    }
}

spei.init.all()
